export const validateIossNumber = (iossNumber: string | undefined) => {
  if (/^[I][M]\d{10}$/.test(iossNumber!)){
    return true;
  } else {
    return false;
  }
};